import { SubstitutionReportType } from '@bp/planung-graphql-types';
import { Table, TableColumns } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type SubstitutionStatisticTypesTableType = {
  type: SubstitutionReportType;
  name: string;
};

type SubstitutionStatisticTypesTableProps = {
  // data: TeachingLoadReportTypesTableType[];
  onSelect: (type: SubstitutionReportType, headline: string) => void;
};

export const SubstitutionStatisticTypesTable = ({ onSelect }: SubstitutionStatisticTypesTableProps) => {
  const { t } = useTranslation();

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const data: SubstitutionStatisticTypesTableType[] = [
    { type: SubstitutionReportType.StatisticTotal, name: t('substitutions.statistics.pdfTotal') },
    { type: SubstitutionReportType.StatisticMonth, name: t('substitutions.statistics.pdfMonthly') },
    { type: SubstitutionReportType.StatisticExcel, name: t('substitutions.statistics.excelMonthly') },
  ];

  const columns: TableColumns<SubstitutionStatisticTypesTableType>[] = [
    {
      header: '',
      id: 'name',
      accessorKey: 'name',
      canExpand: true,
    },
  ];
  return (
    <Table<SubstitutionStatisticTypesTableType>
      data={data}
      columns={columns}
      hideHeader
      onRowClick={(e, row) => {
        setSelectedIndex(parseInt(row.id));
        onSelect(row.original.type, row.original.name);
      }}
      showRowHover
      rowSelection={selectedIndex || selectedIndex === 0 ? { [selectedIndex]: true } : undefined}
      showSelected
      customPadding='var(--spacing-6)'
    />
  );
};
